<!-- eslint-disable vue/no-useless-template-attributes -->
<template>
  <div v-if="catigoria1 === 'Stavroi'">
    <p class="top-title">
      Ο σταυρός είναι ένα σύμβολο κόσμημα. Στο κοσμηματοπωλείο μας θα βρείτε
      μεγάλη ποικιλία απο σταυρούς για γυναίκες , άνδρες ή βαπτιστικούς σταυρούς
      για αγόρι ή κορίτσι , απο πολύτιμα μέταλλα στα 14 ή 18 καράτια. Στη σελίδα
      μας θα δείτε καποια ενδεικτικά σχέδια.
    </p>
  </div>
  <div v-if="catigoria1 === 'Crosses'">
    <p class="top-title">
      The cross is a jewel symbol. In our jewelry store you will find variety of
      crosses for women, men or baptismal crosses for a boy or a girl, from
      precious metals in 14 or 18 carats. On page you will see some indicative
      plans.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Kolie'">
    <p class="top-title">
      Το κολιέ (ή περιδέραιο στα ελληνικά) αναδεικνύει το στυλ κάθε γυναίκας.
      Στο κοσμηματοπωλείο μας θα βρείτε μια ευρεία συλλογή από κολιέ με σύμβολα,
      με ορυκτές πέτρες , με μαργαριτάρια , με μονογράμματα , με διαμάντια , σε
      ασήμι , χρυσό κίτρινο , λευκό ή ροζ στα 14 ή 18 καράτια . Δείτε ένα δείγμα
      στη σελίδα μας, από την πλούσια συλλογή μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Necklace'">
    <p class="top-title">
      The necklace (or necklace in Greek) highlights the style of every woman.
      In our jewelry store you will find a wide collection of necklaces with
      symbols, with mineral stones, with pearls, with monograms, with diamonds,
      silver, yellow, white or rose gold in 14 or 18 carats. See a sample on our
      page, from our rich collection.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Veres'">
    <p class="top-title">
      Βέρες γάμου. Σύμβολο αιώνιας πίστης. Στο κοσμηματοπωλείο μας διαθέτουμε
      μια πλούσια συλλογή απο τα επώνυμα εργαστήρια κατασκευής βερών ,
      Στεργιάδης , Decagold , σε κλασσικά και μοντέρνα σχέδια , σε χρυσό ,
      λευκόχρυσο και ροζ χρυσό. Στις παρακάτω φωτογραφίες σας παρουσιάζουμε ένα
      μέρος της ποικιλίας μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Wedding-Rings'">
    <p class="top-title">
      Wedding rings. Symbol of eternal faith. In our jewelry store we have
      collection from the famous jewelry manufacturing workshops, Stergiadis,
      Decagold, in classic and modern designs, in gold, white gold and rose
      gold. In the following photos we show you one part of our variety.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Vraxiolia'">
    <p class="top-title">
      Είναι το κόσμημα που φοριέται στο χέρι. Ήταν το αγαπημένο κόσμημα των
      ανθρώπων , γυναικών και ανδρών απο την αρχαιότητα. Στο κοσμηματοπωλείο μας
      θα βρείτε μια ευρεία ποικιλία απο βραχιόλια με σύμβολα , χειροπέδες ,
      ριβιέρες απο πολύτιμα μέταλλα σε χρυσό , λευκόχρυσο ή ασήμι.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Bracelets'">
    <p class="top-title">
      It is the jewelry worn on the hand. It was their favorite piece of jewelry
      of people, women and men since ancient times. In our jewelry store find a
      wide variety of bracelets with symbols, handcuffs, rivieras of precious
      metals in gold, platinum or silver.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Mentagion'">
    <p class="top-title">
      Στο κατάστημά μας θα βρείτε μια μεγάλη ποικιλία απο μενταγιόν γυναικεία ,
      κωνσταντινάτα , παιδικά , ζώδια , fashion , με ορυκτές πέτρες , με ζιργκόν
      σε χρυσό 14 καρατίων και σε ασήμι 925 . Στη σελίδα μας θα δείτε ένα δείγμα
      απο την μεγάλη συλλογή μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Pendant'">
    <p class="top-title">
      In our store you will find a wide variety of women's pendants,
      constantinata , children's , zodiac signs , fashion , with mineral stones
      , with zircon in 14 carat gold and 925 silver. On our page you will see a
      sample from our large collection.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Skoularikia'">
    <p class="top-title">
      Αναδείξτε το προσωπικό σας στυλ επιλέγοντας μέσα από τη μεγάλη μας συλλογή
      από σκουλαρίκια. Σκουλαρίκια από ασήμι , χρυσό , λευκόχρυσο , ατσάλι
      ,δίχρωμα , κρίκους , με μαργαριτάρια , με ορυκτές πέτρες , με ζιργκόν. Στη
      σελίδα μας θα δείτε ένα δείγμα από την συλλογή μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Earrings'">
    <p class="top-title">
      Show off your personal style by choosing from our large collection
      earrings. Earrings made of silver, gold, platinum, steel , two-color,
      rings, with pearls, with mineral stones, with zircon. At page you will see
      a sample from our collection.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Monopetra'">
    <p class="top-title">
      Το μονόπετρο δαχτυλίδι θεωρείται ένα ιδανικό δώρο για να κάνετε πρόταση
      γάμου στη σύντροφό σας! Τα μονόπετρα με διαμάντι διατίθενται σε ότι
      μέγεθος και ποιότητα Brilliant επιθυμείτε.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Diamond'">
    <p class="top-title">
      The single stone ring is considered an ideal gift to propose marry your
      partner! Diamond solitaires are available in all size and Brilliant
      quality you want.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Elegance'">
    <p class="top-title">
      Τα εντυπωσιακά δαχτυλίδια είναι για ιδιαίτερες εμφανίσεις και αναβαθμίζουν
      το look σας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Elegance-Rings'">
    <p class="top-title">
      Impressive rings are for special looks and upgrade your look.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Monterna'">
    <p class="top-title">
      Τα μοντέρνα δαχτυλίδια ανεβάζουν τον πήχη του στυλ σας και εγγυώνται
      απαράμιλλες ενημερωμένες εμφανίσεις.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Modern'">
    <p class="top-title">
      Modern rings raise the bar of your style and guarantee unmatched updated
      looks.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Seire'">
    <p class="top-title">
      Τα σειρέ δαχτυλίδια μπορούν να φορεθούν πολλά μαζί ή να συνοδεύσουν βέρα ή
      το μονόπετρό σας , εμπλουτίζοντας τη λάμψη τους.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Eternity'">
    <p class="top-title">
      The eternity rings can be worn together or accompany a wedding ring or
      your single stone, enriching their shine.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Chevalier'">
    <p class="top-title">
      Τα chevalier δαχτυλίδια φοριούνται στο μικρό δάχτυλο , προσδίδοντας
      κομψότητα και αριστοκρατική αίσθηση.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Chevalier-Rings'">
    <p class="top-title">
      The chevalier rings are worn on the little finger, giving elegance and
      classy feel.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Asimenia'">
    <p class="top-title">
      Τα ασημένια δαχτυλίδια είναι μια δημοφιλής επιλογή κοσμήματος και λόγω
      σχεδίων και λόγω προσιτής τιμής. Ανακαλύψτε την μοναδική αισθητική τους
      μέσα απο την πλούσια συλλογή μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Silver'">
    <p class="top-title">
      Silver rings are a popular jewelry choice for a reason designs and due to
      affordable price. Discover their unique aesthetics through our rich
      collection.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Rozeta'">
    <p class="top-title">
      Η ροζέτα, που σημαίνει “μικρό τριαντάφυλλο” , είναι ένα είδος μονόπετρου
      που μοιάζει με λουλούδι. Κατασκευάζεται σε διάφορα σχέδια και κοσμείται
      απο διάφορες πέτρες όπως ζαφείρι , ρουμπίνι , σμαράγδι ή και συνθετικές
      όπως ζιργκόν σε διάφορα χρώματα. Σας παρουσιάζουμε ένα μέρος της ποικιλίας
      μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Rosette'">
    <p class="top-title">
      Rosetta, meaning "little rose", is a type of single stone that looks like
      a flower. It is made in various designs and decorated from various stones
      such as sapphire, ruby, emerald or synthetic such as zirconia in various
      colors. We present you a part of the variety us.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Andrika-daxtilidia'">
    <p class="top-title">
      Τα ανδρικά δαχτυλίδια προσδίδουν στύλ και δυναμικότητα στην εμφάνιση ενός
      άνδρα !!
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Men-Rings'">
    <p class="top-title">
      Men's rings add style and dynamism to one's man appearance!!
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Vraxiolia-Xriso'">
    <p class="top-title">
      Είναι το κόσμημα που φοριέται στο χέρι. Ήταν το αγαπημένο κόσμημα των
      ανθρώπων , γυναικών και ανδρών απο την αρχαιότητα. Στο κοσμηματοπωλείο μας
      θα βρείτε μια ευρεία ποικιλία απο βραχιόλια με σύμβολα , χειροπέδες ,
      ριβιέρες απο πολύτιμα μέταλλα σε χρυσό , λευκόχρυσο ή ασήμι.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Gold-Bracelets'">
    <p class="top-title">
      It is the jewelry worn on the hand. It was their favorite piece of jewelry
      of people, women and men since ancient times. In our jewelry store find a
      wide variety of bracelets with symbols, handcuffs, rivieras of precious
      metals in gold, platinum or silver.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Vraxiolia-Asimi'">
    <p class="top-title">
      Είναι το κόσμημα που φοριέται στο χέρι. Ήταν το αγαπημένο κόσμημα των
      ανθρώπων , γυναικών και ανδρών απο την αρχαιότητα. Στο κοσμηματοπωλείο μας
      θα βρείτε μια ευρεία ποικιλία απο βραχιόλια με σύμβολα , χειροπέδες ,
      ριβιέρες απο πολύτιμα μέταλλα σε χρυσό , λευκόχρυσο ή ασήμι.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Silver-Bracelets'">
    <p class="top-title">
      It is the jewelry worn on the hand. It was their favorite piece of jewelry
      of people, women and men since ancient times. In our jewelry store find a
      wide variety of bracelets with symbols, handcuffs, rivieras of precious
      metals in gold, platinum or silver.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Vraxiolia-Atsali'">
    <p class="top-title">
      Είναι το κόσμημα που φοριέται στο χέρι. Ήταν το αγαπημένο κόσμημα των
      ανθρώπων , γυναικών και ανδρών απο την αρχαιότητα. Στο κοσμηματοπωλείο μας
      θα βρείτε μια ευρεία ποικιλία απο βραχιόλια με σύμβολα , χειροπέδες ,
      ριβιέρες απο πολύτιμα μέταλλα σε χρυσό , λευκόχρυσο ή ασήμι.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Steel-Bracelets'">
    <p class="top-title">
      It is the jewelry worn on the hand. It was their favorite piece of jewelry
      of people, women and men since ancient times. In our jewelry store find a
      wide variety of bracelets with symbols, handcuffs, rivieras of precious
      metals in gold, platinum or silver.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Kolie-Xriso'">
    <p class="top-title">
      Το κολιέ (ή περιδέραιο στα ελληνικά) αναδεικνύει το στυλ κάθε γυναίκας.
      Στο κοσμηματοπωλείο μας θα βρείτε μια ευρεία συλλογή από κολιέ με σύμβολα,
      με ορυκτές πέτρες , με μαργαριτάρια , με μονογράμματα , με διαμάντια , σε
      ασήμι , χρυσό κίτρινο , λευκό ή ροζ στα 14 ή 18 καράτια . Δείτε ένα δείγμα
      στη σελίδα μας, από την πλούσια συλλογή μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Gold-Necklace'">
    <p class="top-title">
      The necklace (or necklace in Greek) highlights the style of every woman.
      In our jewelry store you will find a wide collection of necklaces with
      symbols, with mineral stones, with pearls, with monograms, with diamonds,
      silver, yellow, white or rose gold in 14 or 18 carats. See a sample on our
      page, from our rich collection.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Kolie-Asimi'">
    <p class="top-title">
      Το κολιέ (ή περιδέραιο στα ελληνικά) αναδεικνύει το στυλ κάθε γυναίκας.
      Στο κοσμηματοπωλείο μας θα βρείτε μια ευρεία συλλογή από κολιέ με σύμβολα,
      με ορυκτές πέτρες , με μαργαριτάρια , με μονογράμματα , με διαμάντια , σε
      ασήμι , χρυσό κίτρινο , λευκό ή ροζ στα 14 ή 18 καράτια . Δείτε ένα δείγμα
      στη σελίδα μας, από την πλούσια συλλογή μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Silver-Necklace'">
    <p class="top-title">
      The necklace (or necklace in Greek) highlights the style of every woman.
      In our jewelry store you will find a wide collection of necklaces with
      symbols, with mineral stones, with pearls, with monograms, with diamonds,
      silver, yellow, white or rose gold in 14 or 18 carats. See a sample on our
      page, from our rich collection.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Skoularikia-Xrisa'">
    <p class="top-title">
      Αναδείξτε το προσωπικό σας στυλ επιλέγοντας μέσα από τη μεγάλη μας συλλογή
      από σκουλαρίκια. Σκουλαρίκια από ασήμι , χρυσό , λευκόχρυσο , ατσάλι
      ,δίχρωμα , κρίκους , με μαργαριτάρια , με ορυκτές πέτρες , με ζιργκόν. Στη
      σελίδα μας θα δείτε ένα δείγμα από την συλλογή μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Gold-Earrings'">
    <p class="top-title">
      Show off your personal style by choosing from our large collection
      earrings. Earrings made of silver, gold, platinum, steel , two-color,
      rings, with pearls, with mineral stones, with zircon. At page you will see
      a sample from our collection.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Skoularikia-Asimi'">
    <p class="top-title">
      Αναδείξτε το προσωπικό σας στυλ επιλέγοντας μέσα από τη μεγάλη μας συλλογή
      από σκουλαρίκια. Σκουλαρίκια από ασήμι , χρυσό , λευκόχρυσο , ατσάλι
      ,δίχρωμα , κρίκους , με μαργαριτάρια , με ορυκτές πέτρες , με ζιργκόν. Στη
      σελίδα μας θα δείτε ένα δείγμα από την συλλογή μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Silver-Earrings'">
    <p class="top-title">
      Show off your personal style by choosing from our large collection
      earrings. Earrings made of silver, gold, platinum, steel , two-color,
      rings, with pearls, with mineral stones, with zircon. At page you will see
      a sample from our collection.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Skoularikia-Atsali'">
    <p class="top-title">
      Αναδείξτε το προσωπικό σας στυλ επιλέγοντας μέσα από τη μεγάλη μας συλλογή
      από σκουλαρίκια. Σκουλαρίκια από ασήμι , χρυσό , λευκόχρυσο , ατσάλι
      ,δίχρωμα , κρίκους , με μαργαριτάρια , με ορυκτές πέτρες , με ζιργκόν. Στη
      σελίδα μας θα δείτε ένα δείγμα από την συλλογή μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Steel-Earrings'">
    <p class="top-title">
      Show off your personal style by choosing from our large collection
      earrings. Earrings made of silver, gold, platinum, steel , two-color,
      rings, with pearls, with mineral stones, with zircon. At page you will see
      a sample from our collection.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Stefana'">
    <p class="top-title">
      Τα νυφικά στέφανα συμβολίζουν την ένωση τών δυο ανθρώπων , τους κρίκους
      που ενώνουν την αλυσίδα της ζωής τους . Συνοδεύονται απο δυο καρφίτσες για
      το πέτο .
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Wedding-Crowns'">
    <p class="top-title">
      Wedding crowns symbolize the union of two people, the rings that join the
      chain of their lives. They are accompanied by two pins for the lapel.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Album'">
    <p class="top-title">
      Φυλάξτε τις αναμνήσεις σας σε υπέροχα παιδικά άλμπουμ . Στο κατάστημά μας
      θα βρείτε μια ποικιλία απο όμορφα παιδικά άλμπουμ που αποτελούν ένα
      ιδιαίτερο δώρο για βάπτιση ή γιορτή . Τα άλμπουμ κοσμούνται απο παιδικές
      φιγούρες με λεπτομέρειες σε ασήμι 925.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Albums'">
    <p class="top-title">
      Keep your memories in wonderful children's albums. In our store you will
      find a variety of beautiful children's albums that are one special gift
      for baptism or celebration. The albums are decorated with children's
      figures with details in 925 silver.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Eikones'">
    <p class="top-title">
      Το κοσμηματοπωλείο μας διαθέτει μια μεγάλη ποικιλία απο ασημένιες εικόνες
      με μορφές αγίων και μικρές εικόνες-φυλαχτά απο επιπλατινωμένο ασήμι 925
      για το παιδικό δωμάτιο ή την κούνια του μωρού . Είναι ιδανικά δώρα για
      γάμο , νεογέννητο ή βάπτιση.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Pictures'">
    <p class="top-title">
      Our jewelry store has a wide variety of silver icons with figures of
      saints and small icons-talismans of platinum-plated silver 925 for the
      children's room or the baby's crib. They are ideal gifts for wedding,
      newborn or baptism.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Kornizes'">
    <p class="top-title">
      Υπέροχες κορνίζες απο ασήμι 925 επεξεργασμένες ώστε να διατηρούν την
      αρχική τους γυαλάδα , σε διάφορες διαστάσεις για τις φωτογραφίες σας . Ένα
      όμορφο δώρο για γάμο ή βάπτιση.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Frames'">
    <p class="top-title">
      Beautiful 925 silver frames processed to keep it their original gloss, in
      various dimensions for your photos. One beautiful gift for wedding or
      christening.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Paidika-Vraxiolia'">
    <p class="top-title">
      Παιδικά βραχιόλια για να στολίσουν τα όμορφα παιδικά χεράκια . Στο
      κοσμηματοπωλείο μας θα βρείτε μια ποικιλία από χαριτωμένα παιδικά
      βραχιόλια σε υπέροχα σχέδια και χρώματα από ασήμι 925 και χρυσό 14
      καρατίων. Στη σελίδα μας θα δείτε ένα δείγμα από τη μεγάλη ποικιλία μας.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Children-Bracelets'">
    <p class="top-title">
      Children's bracelets to decorate the beautiful children's hands. In our
      jewelry store you will find a variety of cute children's jewelry bracelets
      in wonderful designs and colors of 925 silver and 14 gold carats. On our
      page you will see a sample of our wide variety.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Paidikes-Tautotites'">
    <p class="top-title">
      Η παιδική ταυτότητα αποτελεί ένα απο τα πρώτα βραχιολάκια στο χέρι ενός
      παιδιού . Στο κατάστημά μας θα βρείτε μια ποικιλία απο παιδικές ταυτότητες
      για κορίτσι ή αγόρι σε χρυσό ή λευκόχρυσο στα 14 καράτια . Χαράσουμε το
      όνομα που επιθυμείτε.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Children-Tags'">
    <p class="top-title">
      The child's tag is one of the first bracelets on one's hand of a child. In
      our store you will find a variety of children's tags for a girl or a boy
      in 14 carat gold or white gold. Let's enjoy it name you want.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Paramanes'">
    <p class="top-title">
      Για εσάς που αναζητάτε ένα μοναδικό δώρο για “ασήμωμα” , στο κατάστημά μας
      θα βρείτε μια υπέροχη συλλογή απο πανέμορφα φυλαχτά για νεογέννητα και
      χαριτωμένες παιδικές παραμάνες σε χρυσό ή λευκόχρυσο σε ιδιαίτερα προσιτές
      τιμές.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Pins'">
    <p class="top-title">
      For those of you who are looking for a unique gift for "coinage", in our
      store you will find a wonderful collection of beautiful charms for
      newborns and cute children's bibs in gold or white gold at very affordable
      prices prices.
    </p>
  </div>
  <div v-else-if="catigoria1 === 'Children-Necklaces'">
    <p class="top-title">
      A baby necklace is a great dangling gift for kids of any age. Necklaces
      with decorative eyes, words, children's figures, can worn by small
      children and by the child's mother. It is one ideal gift with timeless
      value for our little friends.
    </p>
  </div>

  <ais-instant-search
    index-name="tasoulis_price_a"
    :search-client="searchClient"
  >
    <div class="left-panel">
      <ais-clear-refinements />
      <div class="filtra-title">
        <h4 class="el">ΦΙΛΤΡΑ</h4>
        <h4 class="en">FILTERS</h4>
      </div>
      <div class="sort el">
        <ais-sort-by
          :items="[
            { value: 'tasoulis_price_a', label: 'Αυξουσα Τιμή' },
            { value: 'tasoulis_price_d', label: 'Φθίνουσα Τιμή' },
            { value: 'tasoulis_price_f', label: 'Προτεινόμενα' },
            { value: 'tasoulis_date', label: 'Νέες Παραλαβές' },
          ]"
        />
      </div>
      <div class="sort en">
        <ais-sort-by
          :items="[
            { value: 'tasoulis_price_a', label: 'Price: Low to High' },
            { value: 'tasoulis_price_d', label: 'Price: High to Low' },
            { value: 'tasoulis_price_f', label: 'Featured' },
            { value: 'tasoulis_date', label: 'Newest Arrivals' },
          ]"
        />
      </div>
      <h2 class="disno">Κατηγορίες</h2>
      <h2 class="el">Κατηγορίες</h2>
      <h2 class="en">Categories</h2>
      <ais-hierarchical-menu
        :attributes="['Categories', 'sub', 'Lang']"
        :limit="1000"
        :sort-by="['isRefined', 'count:desc']"
      >
        <template>
          <!--<ais-configure
            :disjunctive-facets-refinements.camel="{
              Categories: ['Δαχτυλίδια'],
            }"
          />-->
          <div v-if="searc !== null">
            <ais-configure :query="searc" />
          </div>
        </template>
        <div v-if="catigoria1 === 'Stavroi'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Σταυροί'],
              sub: [],
            }"
          />
        </div>
        <div v-if="catigoria1 === 'Crosses'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Crosses'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Kolie'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Κολιέ'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Necklace'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Necklace'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Xriso-Kolie'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Κολιέ'],
              Μέταλλο: ['Χρυσός Κ14', 'Χρυσός Κ18'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Gold-Necklace'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Necklace'],
              Μέταλλο: ['Gold k14', 'Gold K18'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Asimi-Kolie'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Κολιέ'],
              Μέταλλο: ['Ασήμι'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Silver-Necklace'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Necklace'],
              Μέταλλο: ['Silver'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Alisides'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Αλυσίδες'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Chains'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Chains'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Vraxiolia'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Βραχιόλια'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Bracelets'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Bracelets'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Vraxiolia-Xriso'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Βραχιόλια'],
              Μέταλλο: ['Χρυσός Κ14', 'Χρυσός Κ18'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Gold-Bracelets'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Bracelets'],
              Μέταλλο: ['Gold k14', 'Gold K18'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Vraxiolia-Asimi'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Βραχιόλια'],
              Μέταλλο: ['Ασήμι', 'Ασήμι 925'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Silver-Bracelets'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Bracelets'],
              Μέταλλο: ['Silver', 'Silver 925'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Vraxiolia-Atsali'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Βραχιόλια'],
              Μέταλλο: ['Ατσάλι'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Steel-Bracelets'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Bracelets'],
              Μέταλλο: ['Steel'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Andrika-Vraxiolia'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Ανδρικά κοσμήματα > Ανδρικά βραχιόλια'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Men-Bracelets'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: [`Bracelets > Men's bracelets`],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Daxtilidia'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Δαχτυλίδια'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Rings'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Rings'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Monopetra'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δαχτυλίδια > Μονόπετρα'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Diamond'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Rings > Solitaire'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Εlegance'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δαχτυλίδια > elegance'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Εlegance-Rings'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Rings > Elegance'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Monterna'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δαχτυλίδια > Μοντέρνα'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Modern'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Rings > Modern'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Seire'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δαχτυλίδια > Σειρέ'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Eternity'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Rings > Eternity'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Chevalier'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δαχτυλίδια > Chevalier rings'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Chevalier-Rings'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Rings > Chevalier Rings'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Asimenia'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δαχτυλίδια > Ασημένια'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Silver'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Rings > Silver'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Rozeta'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δαχτυλίδια > Ροζέτα'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Rosette'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Rings > Rosette'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Andrika-daxtilidia'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Ανδρικά κοσμήματα > Ανδρικά δαχτυλίδια'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Men-Rings'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: [`Rings > Men's rings`],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Dora'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Δώρα & Είδη Γάμου'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Gifts'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Gifts'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Gamos'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δώρα & Είδη Γάμου > Είδη Γάμου'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Wedding'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Gifts > Wedding'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Stefana'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δώρα & Είδη Γάμου > Στέφανα'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Wedding-Crowns'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Gifts > wedding crowns'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Album'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δώρα & Είδη Γάμου > Άλμπουμ'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Albums'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Gifts > Album'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Eikones'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δώρα & Είδη Γάμου > Εικόνες'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Pictures'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Gifts > Pictures'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Kornizes'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Δώρα & Είδη Γάμου > Κορνίζες'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Frames'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Gifts > Frames'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Mentagion'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Μενταγιόν'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Pendant'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Pendant'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Monogrammata'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Μενταγιόν > Μονογράμματα'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Monograms'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Pendant > Monogram'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Paidika'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Παιδικά κοσμήματα'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Children'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: [`Children's jewelry`],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Children-Bracelets'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: [`Children's jewelry > Children's Bracelets`],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Paidikes-Tautotites'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Παιδικά κοσμήματα > Παιδικές ταυτότητες'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Children-Tags'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: [`Children's jewelry > Children's Tags`],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Paramanes'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Παιδικά κοσμήματα > Παραμάνες'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Pins'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: [`Children's jewelry > Pins`],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Paidika-Kolie'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: ['Παιδικά κοσμήματα > Παιδικά Κολιέ'],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Children-Necklaces'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              sub: [`Children's jewelry > Children's necklaces`],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Set'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Σετ κοσμημάτων'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Jewelry-Set'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Jewelry set'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Skoularikia'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Σκουλαρίκια'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Earrings'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Earrings'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Xrisa-Skoularikia'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Σκουλαρίκια'],
              Μέταλλο: ['Χρυσός Κ14', 'Χρυσός Κ18'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Gold-Earrings'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Earrings'],
              Μέταλλο: ['Gold K18', 'Gold k14'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Asimi-Skoularikia'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Σκουλαρίκια'],
              Μέταλλο: ['Ασήμι'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Silver-Earrings'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Earrings'],
              Μέταλλο: ['Silver'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Atsali-Skoularikia'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Σκουλαρίκια'],
              Μέταλλο: ['Ατσάλι'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Steel-Earrings'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Earrings'],
              Μέταλλο: ['Steel'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Veres'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Βέρες'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Wedding-Rings'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Wedding Rings'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Prosfores'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Προσφορές'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria1 === 'Offers'">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Categories: ['Offers'],
              sub: [],
            }"
          />
        </div>
        <div v-else-if="catigoria2">
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Lang: ['en'],
            }"
          />
        </div>
        <div v-else>
          <ais-configure
            query=""
            :disjunctive-facets-refinements.camel="{
              Lang: ['el'],
            }"
          />
        </div>
      </ais-hierarchical-menu>
      <ais-hierarchical-menu
        :attributes="['Categories1', 'sub1']"
        :limit="100"
      ></ais-hierarchical-menu>
      <h2 class="el">Τιμή</h2>
      <h2 class="en">Price</h2>
      <ais-range-input attribute="kanonikitimi">
        <template v-slot="{ currentRefinement, range, refine }">
          <vue-slider
            :dot-style="{
              background: '#f26185',
              borderColor: '#f26185',
              boxShadow: '0 0 2px 1px #f26185',
            }"
            :tooltip-style="{ background: '#f26185' }"
            :process-style="{ background: '#f26185' }"
            :min="range.min"
            :max="range.max"
            :model-value="toValue(currentRefinement, range)"
            @change="refine({ min: $event[0], max: $event[1] })"
            step="1"
            thumb-label="always"
          />
        </template>
      </ais-range-input>

      <h2 class="el">Μέταλλο</h2>
      <h2 class="en">Metal</h2>
      <ais-refinement-list
        class="el"
        :sort-by="['isRefined', 'name:asc']"
        attribute="Μέταλλο"
        searchable
        limit="4"
        show-more
        showMoreLabel="Περισσότερα"
        showLessLabel="Λιγότερα"
      >
        <template v-slot:showMoreLabel="{ isShowingMore }">
          {{ !isShowingMore ? "Περισσότερα" : "Λιγότερα" }}
        </template>
      </ais-refinement-list>
      <ais-refinement-list
        class="en"
        :sort-by="['isRefined', 'name:asc']"
        attribute="Μέταλλο"
        searchable
        limit="4"
        show-more
        showMoreLabel="More"
        showLessLabel="Less"
      >
        <template v-slot:showMoreLabel="{ isShowingMore }">
          {{ !isShowingMore ? "More" : "Less" }}
        </template>
      </ais-refinement-list>
      <h2 class="el">Χρώμα</h2>
      <h2 class="en">Color</h2>
      <ais-refinement-list
        class="el"
        :sort-by="['isRefined', 'name:asc']"
        attribute="Χρώμα"
        searchable
        limit="4"
        show-more
        showMoreLabel="Περισσότερα"
        showLessLabel="Λιγότερα"
      >
        <template v-slot:showMoreLabel="{ isShowingMore }">
          {{ !isShowingMore ? "Περισσότερα" : "Λιγότερα" }}
        </template>
      </ais-refinement-list>
      <ais-refinement-list
        class="en"
        :sort-by="['isRefined', 'name:asc']"
        attribute="Χρώμα"
        searchable
        limit="4"
        show-more
        showMoreLabel="More"
        showLessLabel="Less"
      >
        <template v-slot:showMoreLabel="{ isShowingMore }">
          {{ !isShowingMore ? "More" : "Less" }}
        </template>
      </ais-refinement-list>
      <h2 class="el">Πολύτιμες Πέτρες</h2>
      <h2 class="en">Precious Stones</h2>
      <ais-refinement-list
        class="el"
        :sort-by="['isRefined', 'name:asc']"
        attribute="Πέτρα"
        searchable
        limit="4"
        show-more
        showMoreLabel="Περισσότερα"
        showLessLabel="Λιγότερα"
      >
        <template v-slot:showMoreLabel="{ isShowingMore }">
          {{ !isShowingMore ? "Περισσότερα" : "Λιγότερα" }}
        </template>
      </ais-refinement-list>
      <ais-refinement-list
        class="en"
        :sort-by="['isRefined', 'name:asc']"
        attribute="Πέτρα"
        searchable
        limit="4"
        show-more
        showMoreLabel="More"
        showLessLabel="Less"
      >
        <template v-slot:showMoreLabel="{ isShowingMore }">
          {{ !isShowingMore ? "More" : "Less" }}
        </template>
      </ais-refinement-list>
      <h2>Tags</h2>
      <ais-refinement-list
        class="el"
        :sort-by="['isRefined', 'name:asc']"
        attribute="tags"
        searchable
        limit="4"
        show-more
        showMoreLabel="Περισσότερα"
        showLessLabel="Λιγότερα"
      >
        <template v-slot:showMoreLabel="{ isShowingMore }">
          {{ !isShowingMore ? "Περισσότερα" : "Λιγότερα" }}
        </template>
      </ais-refinement-list>
      <ais-refinement-list
        class="en"
        :sort-by="['isRefined', 'name:asc']"
        attribute="tags"
        searchable
        limit="4"
        show-more
        showMoreLabel="More"
        showLessLabel="Less"
      >
        <template v-slot:showMoreLabel="{ isShowingMore }">
          {{ !isShowingMore ? "More" : "Less" }}
        </template>
      </ais-refinement-list>
      <ais-configure :hitsPerPage="9" />
    </div>
    <div class="right-panel">
      <ais-search-box class="el" placeholder="Αναζήτηση..." />
      <ais-search-box class="en" placeholder="Search..." />
      <ais-hits>
        <template v-slot:item="{ item }">
          <div class="card-cont">
            <a class="product-link" :href="item.Slug">
              <img :src="item.Images" />
            </a>
            <div class="outstock" v-if="item.katastasi === 'out of stock'">
              <p class="el">Εξαντλημένο</p>
              <p class="en">Out of stock</p>
            </div>
            <a class="product-link" :href="item.Slug">
              <h2>{{ item.onoma }}</h2>
            </a>
            <p v-if="item.oldtimi == item.kanonikitimi">
              {{ item.kanonikitimi }}€
            </p>
            <p v-else>
              <span class="old">{{ item.oldtimi }}€</span>
              {{ item.kanonikitimi }}€
            </p>
          </div>
          <div class="card-btn el">
            <a
              class="algolia-add-cart"
              :href="'/products/?add-to-cart=' + item.ID"
              data-quantity="1"
              product_sku=""
              rel="nofollow"
            >
              Προσθήκη στο καλάθι
            </a>
          </div>
          <div class="card-btn en">
            <a
              class="algolia-add-cart"
              :href="'/en/products/?add-to-cart=' + item.ID"
              data-quantity="1"
              product_sku=""
              rel="nofollow"
            >
              Add to cart
            </a>
          </div>
        </template>
      </ais-hits>
      <ais-pagination @page-change="pageChange" />
    </div>
  </ais-instant-search>
</template>

<script>
import algoliasearch from "algoliasearch/lite";
import "instantsearch.css/themes/algolia-min.css";
/*import { reactive, toRefs } from "vue";*/
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

export default {
  data() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    var catigoria1 = params.get("category");
    var searc = params.get("sr");
    var test = window.location.href.includes("/en");
    return {
      catigoria1: catigoria1,
      searc: searc,
      catigoria2: test,
      items: [
        {
          category: "Stavroi",
          sub: "",
          text: "Ο σταυρός είναι ένα σύμβολο κόσμημα. Στο κοσμηματοπωλείο μας θα βρείτε μεγάλη ποικιλία απο σταυρούς για γυναίκες , άνδρες ή βαπτιστικούς σταυρούς για αγόρι ή κορίτσι , απο πολύτιμα μέταλλα στα 14 ή 18 καράτια. Στη σελίδα μας θα δείτε καποια ενδεικτικά σχέδια.",
          show: "Σταυροί",
        },
        {
          category: "Kolie",
          sub: "",
          text: "Το κολιέ (ή περιδέραιο στα ελληνικά) αναδεικνύει το στυλ κάθε γυναίκας. Στο κοσμηματοπωλείο μας θα βρείτε μια ευρεία συλλογή από κολιέ με σύμβολα, με ορυκτές πέτρες , με μαργαριτάρια , με μονογράμματα , με διαμάντια , σεασήμι , χρυσό κίτρινο , λευκό ή ροζ στα 14 ή 18 καράτια . Δείτε ένα δείγμαστη σελίδα μας, από την πλούσια συλλογή μας.",
          show: "Κολιέ",
        },
        {
          category: "Veres",
          sub: "",
          text: "Βέρες γάμου. Σύμβολο αιώνιας πίστης. Στο κοσμηματοπωλείο μας διαθέτουμε μια πλούσια συλλογή απο τα επώνυμα εργαστήρια κατασκευής βερών , Στεργιάδης , Decagold , σε κλασσικά και μοντέρνα σχέδια , σε χρυσό , λευκόχρυσο και ροζ χρυσό. Στις παρακάτω φωτογραφίες σας παρουσιάζουμε έναμέρος της ποικιλίας μας.",
          show: "Βέρες",
        },
        {
          category: "Vraxiolia",
          sub: "",
          text: "Είναι το κόσμημα που φοριέται στο χέρι. Ήταν το αγαπημένο κόσμημα των ανθρώπων , γυναικών και ανδρών απο την αρχαιότητα. Στο κοσμηματοπωλείο μας θα βρείτε μια ευρεία ποικιλία απο βραχιόλια με σύμβολα , χειροπέδες , ριβιέρες απο πολύτιμα μέταλλα σε χρυσό , λευκόχρυσο ή ασήμι.",
          show: "Βραχιόλια",
        },
        {
          category: "Mentagion",
          sub: "",
          text: "Στο κατάστημά μας θα βρείτε μια μεγάλη ποικιλία απο μενταγιόν γυναικεία , κωνσταντινάτα , παιδικά , ζώδια , fashion , με ορυκτές πέτρες , με ζιργκόν σε χρυσό 14 καρατίων και σε ασήμι 925 . Στη σελίδα μας θα δείτε ένα δείγμα απο την μεγάλη συλλογή μας.",
          show: "Μενταγιόν",
        },
        {
          category: "Skoularikia",
          sub: "",
          text: "",
          show: "Σκουλαρίκια",
        },
        { category: "Prosfores", sub: "", text: "", show: "Προσφορές" },
      ],
      searchClient: algoliasearch(
        "APW4EG85VC",
        "1162d8e5f6a942a5204b5812c70c02c6"
      ),
    };
  },
  components: {
    VueSlider,
  },
  /*setup() {
    const data = reactive({ value: 0 });
    return toRefs(data);
  },*/
  methods: {
    toValue(value, range) {
      return [
        typeof value.min === "number" ? value.min : range.min,
        typeof value.max === "number" ? value.max : range.max,
      ];
    },
    pageChange() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
  },
};
</script>

<style>
.ais-HierarchicalMenu-item {
  padding-top: 10px;
  padding-bottom: 10px;
}

.ais-HierarchicalMenu-label {
  color: #222222;
}
.ais-HierarchicalMenu-count,
.ais-Menu-count,
.ais-RefinementList-count,
.ais-ToggleRefinement-count {
  font-size: 0px;
  position: absolute;
  top: 10px;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #eee;
  border-radius: 50%;
}
.ais-HierarchicalMenu-label {
  margin-left: 40px;
}
.ais-HierarchicalMenu-item {
  position: relative;
}
.disno {
  display: none !important;
}
body {
  font-family: sans-serif;
  padding: 1em;
}

.product-link {
  text-decoration: none;
}

.product-link h2 {
  color: #222222;
}

.ais-Pagination {
  margin-top: 40px !important;
}
.ais-Pagination-item {
  border-radius: 0px;
  margin-left: 0px !important;
}

.ais-Pagination-link {
  border-radius: 0px;
  padding: 0.7em;
  color: #f26185;
}

.ais-Pagination-item--selected .ais-Pagination-link {
  color: #fff;
  background-color: #f26185;
  border-color: #f26185;
}
.ais-InstantSearch {
  max-width: 1350px !important;
  gap: 100px;
  margin-left: auto;
  margin-right: auto;
}

.ais-InstantSearch {
  display: flex !important;
}

.ais-InstantSearch .left-panel {
  padding: 0px 20px;
  width: 22%;
}

.ais-InstantSearch .right-panel {
  width: 78%;
}

.ais-InfiniteHits-item,
.ais-InfiniteResults-item,
.ais-Hits-item,
.ais-Results-item {
  width: 30% !important;
}

.ais-Hits-item {
  text-align: center;
  margin-bottom: 0px !important;
  border-radius: 20px;
  text-align: center !important;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.card-btn {
  line-height: 60px !important;
}
.ais-SearchBox-input,
.ais-SearchBox-submit {
  display: none;
}
.right-panel .ais-SearchBox-input,
.right-panel .ais-SearchBox-submit {
  display: block;
}

.ais-SearchBox-submit {
  right: 1.3rem;
  left: auto;
}
.ais-SearchBox-input {
  padding: 10px 20px;
  border-radius: 20px;
  background: #ffdfdf !important;
}
.ais-SearchBox {
  margin-bottom: 30px;
}

.ais-Hits-item img {
  background: #e3e3e3;
  width: 100% !important;
  height: 280px !important;
  object-fit: cover !important;
  box-shadow: 0 7px 12px rgb(97 45 0 / 21%) !important;
  border-radius: 10px !important;
}

.ais-Hits-item {
  cursor: pointer;
  align-items: center;
  margin-bottom: 20px;
  background: #efdee2 !important;
  padding: 20px;
  padding-bottom: 30px !important;
  border-radius: 5px;
  box-shadow: 0 7px 12px rgb(97 45 0 / 21%) !important;
}

.ais-Hits-item h2 {
  font-size: 22px;
  margin: 0;
  font-weight: 400 !important;
  margin-bottom: 5px !important;
  margin-top: 15px !important;
}

.ais-Hits-item p {
  font-size: 18px;
  color: #da6682;
  font-weight: 700 !important;
  margin-bottom: 15px;
}

.algolia-add-cart {
  border-radius: 20px !important;
  background: linear-gradient(
    to bottom right,
    #f26185,
    #f26185,
    #ffbfcf,
    #f26185,
    #f26185
  ) !important;
  padding: 12px 25px !important;
  font-size: 18px !important;
  color: #fff !important;
  text-decoration: none !important;
}

.algolia-add-cart:hover {
  background: linear-gradient(
    to bottom right,
    #c33054,
    #c33054,
    #ffbfcf,
    #c33054,
    #c33054
  ) !important;
}

.ais-RefinementList-list,
.ais-HierarchicalMenu-list {
  display: block;
  position: relative;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.ais-RefinementList-labelText,
.ais-HierarchicalMenu-label {
  margin-left: 40px;
}
/* Hide the browser' s default checkbox */
.ais-RefinementList-list input,
.ais-HierarchicalMenu-list input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.ais-RefinementList-count,
.ais-HierarchicalMenu-count {
  font-size: 0px;
  position: absolute;
  top: 10px;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #eee;
  border-radius: 50%;
}
.ais-Hits-list {
  gap: 20px;
}

.ais-InfiniteHits-item,
.ais-InfiniteResults-item,
.ais-Hits-item,
.ais-Results-item {
  border: 0px solid !important;
}
/* On mouse-over, add a grey background color */
/*.ais-RefinementList-list input:hover input ~ .ais-RefinementList-count {
  background-color: #ccc;
}*/
.ais-RefinementList-item,
.ais-HierarchicalMenu-item {
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
}

.ais-Highlight {
  font-size: 16px;
}

.ais-Highlight,
.ais-RefinementList-count,
.ais-HierarchicalMenu-count {
  cursor: pointer;
}
/* When the checkbox is checked, add a blue background */
.ais-RefinementList-list input:checked ~ .ais-RefinementList-count,
.ais-HierarchicalMenu-list
  .ais-HierarchicalMenu-link--selected
  .ais-HierarchicalMenu-count {
  background-color: #f26185;
}

/* Create the checkmark/indicator (hidden when not checked) */
.ais-RefinementList-count:after,
.ais-HierarchicalMenu-count:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.ais-RefinementList-list input:checked ~ .ais-RefinementList-count:after,
.ais-HierarchicalMenu-list
  .ais-HierarchicalMenu-link--selected
  .ais-HierarchicalMenu-count:after {
  display: block;
}

/* Style the checkmark/indicator */
.ais-RefinementList-list .ais-RefinementList-count:after,
.ais-HierarchicalMenu-list .ais-HierarchicalMenu-count:after {
  left: 7px;
  top: 5px;
  width: 5px;
  height: 8px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.ais-RefinementList-item,
.ais-HierarchicalMenu-item {
  position: relative;
}

/*.ais-RefinementList-showMore:before {
  content: "Περισσότερα";
  font-size: 16px;
}

.ais-RefinementList-showMore:focus:before {
  content: "Λιγότερα";
  font-size: 16px;
}*/

.ais-RefinementList-showMore {
  background: transparent !important;
  padding: 0px 0px !important;
  font-size: 17px !important;
  color: #f26185 !important;
  text-decoration: none !important;
  padding-bottom: 20px !important;
}
.ais-RefinementList-showMore:hover {
  background: transparent !important;
  color: #bd3758 !important;
}

.vue-slider-dot-tooltip-inner {
  border-color: #f26185;
  background-color: #f26185;
}

.ais-Pagination-item:hover a {
  color: #f26185;
}
@media only screen and (max-width: 1300px) {
  .ais-InfiniteHits-item,
  .ais-InfiniteResults-item,
  .ais-Hits-item,
  .ais-Results-item {
    width: 40% !important;
  }
}

@media only screen and (max-width: 992px) {
  .ais-InfiniteHits-item,
  .ais-InfiniteResults-item,
  .ais-Hits-item,
  .ais-Results-item {
    width: 90% !important;
  }

  .ais-Hits-item {
    margin-bottom: 30px !important;
  }
  .ais-InstantSearch .left-panel {
    width: 100%;
    text-align: center !important;
  }

  .ais-InstantSearch .right-panel {
    width: 70%;
    margin-left: auto;
    margin-right: auto;
  }

  .ais-InstantSearch {
    flex-direction: column-reverse !important;
    justify-content: center !important;
    gap: 40px;
  }
}

.ais-SortBy-select {
  border-radius: 2px;
  padding: 10px 20px;
  width: 100%;
  background-color: #ffe6ec;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 10px 20px;
}
option {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 5px;
}
</style>
